export const environment = {
  production: false,
  eliquaRestURL: 'https://biologikoxorio.uat.qivos.net/ci-biologikoxorio-UAT/rest/v1/',
  clientName: 'biologikoxorio',
};
